<template>
  <modal
    v-slot="{ data }"
    name="claimGiftedPointsModal"
    modal-style="compact"
    :display-header-title="false"
  >
    <claim-gifted-points
      :view-type="data.viewType"
      :gifted-points="data.giftedPoints"
    />
  </modal>
</template>


<script>
  import ClaimGiftedPoints from './claim-gifted-points/index.vue';


  export default {
    name: 'ClaimGiftedPointsModal',

    components: {
      ClaimGiftedPoints
    }
  };
</script>
